import { render, staticRenderFns } from "./HomePerks.vue?vue&type=template&id=a0c962ca"
import script from "./HomePerks.vue?vue&type=script&lang=js"
export * from "./HomePerks.vue?vue&type=script&lang=js"
import style0 from "./HomePerks.vue?vue&type=style&index=0&id=a0c962ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports